/**
 * Public legal pages a technician session may stay on.
 *
 * Google Play requires the Delete account / privacy / cookies URLs to be
 * reachable from inside the app, so the technician guard must not bounce them
 * to /technician. Kept in its own module because both the router guard and the
 * native session repair in App.vue have to honour the same list, and importing
 * the whole router into App.vue for it would add a needless dependency edge.
 */
export const TECH_SESSION_PUBLIC_PATHS = new Set([
  '/privacy',
  '/terms',
  '/cookies',
  '/delete-account',
  '/accept-company-invite',
])

/**
 * Technician sessions cannot open the office LMS (the catalog and team
 * progress live there). My Learning and a specific course player remap onto
 * the technician shell. Every other /lms path stays unmapped so the guard
 * still sends it to the technician home.
 *
 * `to` is a route location (`path`, optional `query` / `hash`) or a path
 * string. Returns null when the path is not an assigned-learning page.
 */
export function technicianLearningLocation(to) {
  const raw = typeof to === 'string' ? to : to?.path
  if (!raw || typeof raw !== 'string') return null
  const bare = raw.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/'
  let path = null
  if (bare === '/lms/my-learning') path = '/technician/learning'
  else {
    const learn = bare.match(/^\/lms\/learn\/(\d+)$/)
    if (learn) path = `/technician/learning/${learn[1]}`
  }
  if (!path) return null
  if (typeof to === 'string') return { path }
  return { path, query: to.query, hash: to.hash }
}
